module.exports = __webpack_public_path__ + "img/high-low_temp.d989a5ad.jpg";